<template>
  <div id="app">
    <transition>
      <keep-alive :include="cacheViews">
        <router-view />
      </keep-alive>
    </transition>
    <t-tabbar />
    <bindPhone />
  </div>
</template>

<script>
import tTabbar from '@/components/tabbar'
import bindPhone from '@/components/bindPhone/index'
export default {
  name: 'App',
  components: {
    tTabbar,
    bindPhone
  },
  data: () => ({
    cacheViews: []
  }),
  watch: {
    $route(route) {
      if (route.meta.keepAlive) {
        const name = route.matched[0] && route.matched[0].components.default.name
        this.cacheViews = this.cacheViews.concat(name)
      }
    }
  }
}
</script>

<style lang="less" scoped>
html {
  height: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100vw;
  height: 100%;
  // 此属性会影响 vant-list 触底加载事件
  // overflow-x: hidden;
}
</style>
